import BookingComponent from "../components/Booking.component";

const bookingRoutes = {
  paths: [
    '/booking/crunchone',
    '/booking/trainer-day',
  ],
  exact: true,
  component: BookingComponent
}

const routes = [
  bookingRoutes,
]
  .map(({ paths, ...rest }) => paths.map((path) => ({ path, ...rest })))
  .flat();

export default routes